/* AllySabers R8.6: small enhancements on top of R8.
   1. The announcement line: one message at a time, taking turns. Hovering or focusing holds the current message;
      with reduced motion the first message simply stays.
   2. Saber Finder (the <ig-finder> from ally-r711.js):
      - dueling now points to Base-Lit, the toughest core, as the FAQ says;
      - "young Jedi" wording becomes "younger fan";
      - coming back from a product page (browser Back) shows your result again instead of question one. */
(() => {
  /* ------------------------------------------------------------ */
  /* 1. Announcement                                              */
  /* ------------------------------------------------------------ */

  const tickers = () => {
    document.querySelectorAll('[data-ally-ticker]').forEach(bar => {
      if (bar.dataset.tickerReady) return;
      bar.dataset.tickerReady = '1';
      const items = [...bar.querySelectorAll('.ally-announcement__item')];
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let i = Math.max(0, items.findIndex(el => el.classList.contains('is-active')));
      let held = false;
      ['mouseenter', 'focusin'].forEach(t => bar.addEventListener(t, () => { held = true; }));
      ['mouseleave', 'focusout'].forEach(t => bar.addEventListener(t, () => { held = false; }));
      setInterval(() => {
        if (held || document.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  };

  /* ------------------------------------------------------------ */
  /* 2. Saber Finder                                              */
  /* ------------------------------------------------------------ */

  const STORE = 'allyFinder.r86';
  const WEIGHTS = {
    who: { first: { base: 1, xeno: 2 }, collector: { xeno: 1, proffie: 3 }, gift: { base: 1, xeno: 2 }, kid: { base: 4 } },
    // Base-Lit has nothing in the blade to break, so dueling and spinning lean on it harder than before
    use: { duel: { base: 4, xeno: 1 }, show: { xeno: 3, proffie: 2 }, display: { xeno: 2, proffie: 1 }, mix: { base: 1, xeno: 2 } }
  };
  const TIE = ['xeno', 'base', 'proffie'];

  const session = {
    get() { try { return JSON.parse(sessionStorage.getItem(STORE) || 'null'); } catch (e) { return null; } },
    set(v) { try { sessionStorage.setItem(STORE, JSON.stringify(v)); } catch (e) { /* private mode */ } },
    clear() { try { sessionStorage.removeItem(STORE); } catch (e) { /* private mode */ } }
  };

  const backNav = () => {
    try { return (performance.getEntriesByType('navigation')[0] || {}).type === 'back_forward'; } catch (e) { return false; }
  };

  const patchFinder = () => {
    const Finder = customElements.get('ig-finder');
    if (!Finder || Finder.prototype.allyR86) return !!Finder;
    Finder.prototype.allyR86 = true;

    Finder.prototype.pickCore = function pickCore() {
      const s = { base: 0, xeno: 0, proffie: 0 };
      const add = w => w && Object.keys(w).forEach(k => (s[k] += w[k]));
      add(WEIGHTS.who[this.answers.who]);
      add(WEIGHTS.use[this.answers.use]);
      const limit = parseInt(this.answers.budget, 10);
      if (limit > 0 && limit <= ((this.copy && this.copy.low) || 15000)) s.base += 2;
      else if (this.answers.budget === '0') { s.proffie += 1; s.xeno += 1; }
      else if (limit > 0) s.xeno += 1;
      return TIE.slice().sort((a, b) => s[b] - s[a] || TIE.indexOf(a) - TIE.indexOf(b))[0];
    };
    return true;
  };

  // wording fixes on a finished result, and remember it for the Back button
  const onResult = e => {
    const finder = e.target.closest && e.target.closest('ig-finder');
    if (!finder) return;
    const why = finder.querySelector('[data-finder-why]');
    if (why) {
      let text = why.textContent.replace(/young Jedi/g, 'younger fan');
      const { core, answers } = e.detail || {};
      if (answers && answers.use === 'duel' && core && core !== 'base') {
        const cut = text.indexOf(' Below:');
        const rest = cut > -1 ? text.slice(cut) : '';
        const name = core === 'proffie' ? 'Proffie' : 'Xenopixel';
        text = `${name} handles controlled dueling and adds the full pixel-blade effects. For hard, everyday contact, Base-Lit is the toughest choice.${rest}`;
      }
      why.textContent = text;
    }
    finder.querySelectorAll('[data-finder-answers] li').forEach(li => {
      if (li.textContent === 'Young Jedi') li.textContent = 'Younger fan';
    });
    if (!finder.closest('.ig-quiz') && e.detail && e.detail.answers) session.set(e.detail.answers);
  };

  const restore = finder => {
    if (finder.dataset.r86 || finder.closest('.ig-quiz')) return;
    finder.dataset.r86 = '1';
    // starting over forgets the saved result
    finder.querySelectorAll('[data-finder-reset], [data-finder-retake]').forEach(b => b.addEventListener('click', () => session.clear()));
    const saved = session.get();
    if (!saved || !backNav() || !finder.steps || typeof finder.show !== 'function') return;
    let complete = true;
    finder.steps.forEach(step => {
      const q = step.dataset.q;
      const opt = q && saved[q] != null && step.querySelector(`.ig-finder__opt[data-value="${CSS.escape(String(saved[q]))}"]`);
      if (!opt) { complete = false; return; }
      step.querySelectorAll('.ig-finder__opt').forEach(o => o.setAttribute('aria-pressed', o === opt ? 'true' : 'false'));
    });
    if (!complete) return;
    finder.answers = Object.assign({}, saved);
    finder.show(finder.steps.length, false);
  };

  const finders = () => {
    if (!patchFinder()) return;
    document.querySelectorAll('ig-finder').forEach(restore);
  };

  const run = () => {
    tickers();
    finders();
  };

  document.addEventListener('finder:result', onResult);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // the finder element may be defined after this file runs
  if (!customElements.get('ig-finder')) customElements.whenDefined('ig-finder').then(finders);
  document.addEventListener('shopify:section:load', run);
})();
